export const DEFAULT_PRODUCTS_FILTER_PANEL_TEXT = "Filters";
const PRODUCTS_FILTER_PANEL_CLASSES_PREFIX = "ProductsFiltersPanel";

export const PRODUCTS_FILTERS_CLASSES = {
  drawer: `${PRODUCTS_FILTER_PANEL_CLASSES_PREFIX}-productsFiltersDrawer`,
  showButton: `${PRODUCTS_FILTER_PANEL_CLASSES_PREFIX}-productsFiltersShowButton`,
  filterContentWrapper: `${PRODUCTS_FILTER_PANEL_CLASSES_PREFIX}-productsFilterContentWrapper`,
  filterTopBar: `${PRODUCTS_FILTER_PANEL_CLASSES_PREFIX}-productsFilterTopBar`,
  filterTitle: `${PRODUCTS_FILTER_PANEL_CLASSES_PREFIX}-productsFilterTitle`,
  filterTopBarMobileSticky: `${PRODUCTS_FILTER_PANEL_CLASSES_PREFIX}-productsFilterTopBarMobileSticky`,
  filterTopBarMobile: `${PRODUCTS_FILTER_PANEL_CLASSES_PREFIX}-productsFilterTopBarMobile`,
  filterBtnMobile: `${PRODUCTS_FILTER_PANEL_CLASSES_PREFIX}-productsFilterBtnMobile`,
};
